/* eslint-disable */
export default {
  schedule: 'Agendar reunião',
  prompt: 'Autorize a RingCentral a acessar as informações da sua conta.',
  saveAsDefault: 'Salvar como padrão',
  launchMeeting: 'Iniciar reunião',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
